import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DeviationService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list of deviation types.
     *
     * @datatask 43
     * @datataskName sp_ws_p2_deviationtype_list
     * @param params settings for the list.
     * @returns promise containing list of deviation types.
     */
    public getDeviationTypes(params?: GetDeviationTypesParams): Promise<DeviationTypeItem[]> {
        return this.datatask.Post(43, params);
    }

    /**
     * Retrieves deviation sources for the given deviation type.
     *
     * @datatask 44
     * @datataskName sp_ws_p2_deviationsource_list
     * @param params settings for the list.
     * @returns promise containing list of deviation sources.
     */
    public getDeviationSources(params: GetDeviationSourcesParams): Promise<DeviationSourceItem[]> {
        return this.datatask.Post(44, params);
    }

    /**
     * Retrieves deviation sources for the given deviation source.
     *
     * @datatask 45
     * @datataskName sp_ws_p2_deviationsource2_list
     * @param params settings for the list.
     * @returns promise containing list of deviation sources.
     */
    public getDeviationSources2(params: GetDeviationSources2Params): Promise<DeviationSourceItem[]> {
        return this.datatask.Post(44, params);
    }
}

export interface GetDeviationTypesParams {
    isactive?: '1' | '0' | 'ALL';
    activitytype_no?: string | number;
}

export interface GetDeviationSourcesParams {
    deviationtype_keyno: string | number;
}

export interface GetDeviationSources2Params {
    deviationsource_keyno: string | number;
}

export interface DeviationTypeItem {
    deviationtype_keyno: string | number;
    deviationtype_name: string;
    item_id: string;
    item_name: string;
    item_state: string;
    item_parms: string;
    item_path: string;
    orderby: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
}

export interface DeviationSourceItem {
    deviationsource_keyno: string;
    deviationsource_name: string;
}
